export const TagValue = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  ONLINE: 'Online',
  OFFLINE: 'Offline',
  DISABLED: 'Disabled',
  NO_STATUS: 'NoStatus',
  NOT_LINKED: 'NotLinked',
  UNPUBLISHED: 'Unpublished',
  DOWNLOADING: 'Downloading',
  PENDING: 'Pending',
  UPDATING: 'Updating',
  OUT_OF_RANGE: 'OutOfRange',
  READY: 'Ready',
  ON_DEVICE: 'OnDevice',
  SYNCHRONIZING: 'Synchronizing',
  SYNCHRONIZATION_PENDING: 'SynchronizationPending',
  SYNCHRONIZED: 'Synchronized',
  NO_CONTENT: 'NoContent',
  PUBLISHED: 'Published',
  DRAFTED: 'Drafted',
  UNREGISTERED: 'Unregistered',
  PREPARING: 'Preparing',
  IN_PROGRESS: 'InProgress',
  RENDERING_COMPLETED: 'RenderingCompleted',
  COMPLETED: 'Completed',
  FAILED: 'Failed',
  CANCELED: 'Canceled',
  PREVIEW: 'Preview',
  FULL_VIDEO: 'FullVideo',
  DOWNLOADED_FOR_OFFLINE: 'DownloadedForOffline',
  DEFAULT: 'Default'
};

export const TAGS_STYLES = {
  [TagValue.ACTIVE]:
    'border-accent-green md:border-accent-light-green bg-accent-green md:bg-accent-light-green text-accent-green',
  [TagValue.INACTIVE]:
    'border-accent-amber md:border-accent-peach bg-accent-amber md:bg-accent-peach text-accent-red',
  [TagValue.ONLINE]:
    'border-accent-green md:border-accent-light-green bg-accent-green md:bg-accent-light-green text-accent-green',
  [TagValue.OFFLINE]: 'border-accent-light-red bg-accent-light-red text-accent-red',
  [TagValue.NOT_LINKED]: 'bg-second-accent-light-gray text-accent-dark-gray',
  [TagValue.UNPUBLISHED]: 'border-accent-light-red bg-accent-light-red text-accent-red',
  [TagValue.PENDING]: 'border-accent-light-yellow bg-accent-light-yellow !text-accent-yellow',
  [TagValue.UPDATING]: 'border-accent-light-yellow bg-accent-light-yellow !text-accent-yellow',
  [TagValue.OUT_OF_RANGE]: 'border-accent-light-blue bg-accent-light-blue !text-accent-blue',
  [TagValue.ON_DEVICE]:
    'border-second-accent-light-green bg-second-accent-light-green !text-second-accent-green',
  [TagValue.READY]:
    'border-second-accent-light-green bg-second-accent-light-green !text-second-accent-green',
  [TagValue.DOWNLOADING]: 'border-accent-light-blue bg-accent-light-blue !text-accent-blue',
  [TagValue.DISABLED]: 'bg-second-accent-light-gray text-accent-dark-gray',
  [TagValue.SYNCHRONIZING]: 'border-accent-light-yellow bg-accent-light-yellow !text-accent-yellow',
  [TagValue.SYNCHRONIZATION_PENDING]:
    'border-accent-light-yellow bg-accent-light-yellow !text-accent-yellow',
  [TagValue.SYNCHRONIZED]:
    'border-second-accent-light-green bg-second-accent-light-green !text-second-accent-green',
  [TagValue.NO_STATUS]: 'border-accent-light-yellow bg-accent-light-yellow !text-accent-yellow',
  [TagValue.NO_CONTENT]: 'border-accent-light-yellow bg-accent-light-yellow !text-accent-yellow',
  [TagValue.PUBLISHED]:
    'border-accent-green md:border-accent-light-green bg-accent-green md:bg-accent-light-green text-accent-green',
  [TagValue.DRAFTED]: 'bg-second-accent-light-gray text-accent-dark-gray',
  [TagValue.UNREGISTERED]: 'border-accent-light-yellow bg-accent-light-yellow !text-accent-yellow',
  [TagValue.PREPARING]: 'bg-accent-light-orange text-accent-orange',
  [TagValue.IN_PROGRESS]: 'bg-accent-light-dark-blue text-accent-dark-blue',
  [TagValue.RENDERING_COMPLETED]: 'bg-accent-light-purple text-accent-purple',
  [TagValue.COMPLETED]:
    'border-accent-green md:border-accent-light-green bg-accent-green md:bg-accent-light-green text-accent-green',
  [TagValue.FAILED]: 'border-accent-light-red bg-accent-light-red text-accent-red',
  [TagValue.CANCELED]: 'bg-second-accent-light-gray text-accent-dark-gray',
  [TagValue.PREVIEW]: 'border-accent-light-orange bg-accent-light-orange text-accent-orange',
  [TagValue.FULL_VIDEO]: 'border-accent-light-blue bg-accent-light-blue !text-accent-blue',
  [TagValue.DOWNLOADED_FOR_OFFLINE]:
    'border-second-accent-light-green bg-second-accent-light-green !text-second-accent-green',
  [TagValue.DEFAULT]:
    'border-second-accent-light-green bg-second-accent-light-green !text-second-accent-green'
};
